<div class="pricing-grid">
  <!-- Tooltip headline -->
  <div
    class="pricing-grid__headline ds-heading--s ds-color--white pb-4"
  >{{'productDetails.pricingDetails' | cxTranslate}}</div>
  <!-- One Time Set up Fees -->
  <ng-container *ngIf="!!ratePlan?.setupFees?.length">
    <div
      class="pricing-grid__headline ds-heading--xs ds-color--white"
    >{{'productDetails.oneTime' | cxTranslate}}</div>
    <ng-container *ngFor="let setupFee of ratePlan?.setupFees; let i = index">
      <span
        [class.pt-2]="i > 0"
        [class.pt-3]="i == 0"
        class="ds-fine-print ds-color--grey-4 pricing-grid__left text-capitalize"
      >{{setupFee.metric?.name + ':'}}</span>
      <span
        [class.pt-2]="i > 0"
        [class.pt-3]="i == 0"
        class="ds-fine-print ds-color--white pricing-grid__right"
      >{{ratePlan?.currency + ' ' + (setupFee.price?.amount | priceFormat)}}</span>
    </ng-container>
  </ng-container>
  <!-- Price periodicity -->
  <ng-container *ngIf="!!ratePlan?.periodicity?.name">
    <div *ngIf="ratePlan?.setupFees?.length" class="my-4 separator pricing-grid__headline w-100"></div>
    <span
      class="pricing-grid__headline ds-heading--xs ds-color--white text-capitalize"
    >{{'productDetails.perUnit' | cxTranslate: {unit: ratePlan?.periodicity?.name} }}</span>
  </ng-container>
  <!-- Plan block rate -->
  <ng-container *ngFor="let blockRate of ratePlan?.blockRates; let i = index">
    <span
      [class.pt-2]="i > 0"
      [class.pt-3]="i == 0"
      class="ds-fine-print ds-color--grey-4 pricing-grid__left text-capitalize"
    >{{'productDetails.perAmountOfUnit' | cxTranslate: {
      amount: blockRate.blockSize,
      unit: blockRate.metric?.name
    } }}</span>
    <span [class.pt-2]="i > 0" [class.pt-3]="i == 0" class="ds-fine-print ds-color--white pricing-grid__right"
    >{{ratePlan?.currency + ' ' + (blockRate.pricePerBlock?.amount | priceFormat)}}</span>
  </ng-container>
  <!-- Plan fix rate -->
  <ng-container *ngFor="let fixedRate of ratePlan?.fixedRates; let i = index">
    <span
      [class.pt-2]="i > 0 || ratePlan?.blockRates?.length"
      [class.pt-4]="i == 0 && !ratePlan?.blockRates?.length"
      class="ds-fine-print ds-color--grey-4 pricing-grid__left text-capitalize"
    >{{fixedRate.metric?.name + ':'}}</span>
    <span
      [class.pt-2]="i > 0 || ratePlan?.blockRates?.length"
      [class.pt-4]="i == 0 && !ratePlan?.blockRates?.length"
      class="ds-fine-print ds-color--white pricing-grid__right"
    >{{ratePlan?.currency + ' ' + (fixedRate.price?.amount | priceFormat)}}</span>
  </ng-container>
  <!-- Plan all unit volume rates -->
  <ng-container *ngFor="let allUnitVolumeRate of ratePlan?.allUnitVolumeRates">
    <span class="pt-4 ds-fine-print ds-color--grey-4 pricing-grid__left">
      <span class="text-capitalize">{{allUnitVolumeRate.metric?.name}}</span>
      <span>{{'(s)'}}</span>
    </span>
    <span
      class="pt-4 ds-fine-print ds-color--grey-4 pricing-grid__right"
    >{{(allUnitVolumeRate.blockSize > 1
      ? 'productDetails.pricePerAmountOfUnitsPerPeriod'
      : 'productDetails.pricePerUnitPerPeriod') | cxTranslate: {
      amount: allUnitVolumeRate.blockSize,
      unit: allUnitVolumeRate.metric?.name,
      period: ratePlan.periodicity?.name
    } }}</span>
    <ng-container *ngFor="let tier of allUnitVolumeRate.tiers; let i = index">
      <!-- number of users -->
      <span
        *ngIf="i === 0 && allUnitVolumeRate?.tiers?.length === 1"
        class="pt-2 ds-fine-print ds-color--white pricing-grid__left"
      >{{allUnitVolumeRate.minimumBlocks + '+'}}</span>
      <span
        *ngIf="i === 0 && allUnitVolumeRate?.tiers?.length > 1"
        class="pt-2 ds-fine-print ds-color--white pricing-grid__left"
      >{{allUnitVolumeRate.minimumBlocks + ' - ' + tier.bound}}</span>
      <span
        *ngIf="i > 0 && i < allUnitVolumeRate.tiers.length - 1"
        class="pt-2 ds-fine-print ds-color--white pricing-grid__left"
      >{{allUnitVolumeRate.tiers[i - 1].bound + 1 + ' - ' + tier.bound}}</span>
      <span
        *ngIf="i !== 0 && i === allUnitVolumeRate.tiers.length - 1"
        class="pt-2 ds-fine-print ds-color--white pricing-grid__left"
      >{{(allUnitVolumeRate.tiers[i - 1].bound + 1) + '+'}}</span>
      <!-- cost -->
      <span
        class="pt-2 ds-fine-print ds-color--white pricing-grid__right">{{ratePlan?.currency + ' ' + (tier.pricePerBlock?.amount | priceFormat)}}</span>
    </ng-container>
  </ng-container>
  <!-- Plan tier rates -->
  <ng-container *ngFor="let tierRate of ratePlan?.tierRates">
    <span class="pt-4 ds-fine-print ds-color--grey-4 pricing-grid__left">
      <span class="text-capitalize">{{tierRate.metric?.name}}</span>
      <span>{{'(s)'}}</span>
    </span>
    <span
      class="pt-4 ds-fine-print ds-color--grey-4 pricing-grid__right"
    >{{'productDetails.pricePerUnitPerPeriod' | cxTranslate: {
      unit: tierRate.metric?.name,
      period: ratePlan?.periodicity?.name
    } }}</span>
    <ng-container *ngFor="let tier of tierRate?.tiers; let i = index">
      <!-- number of users -->
      <span
        *ngIf="i === 0 && tierRate?.tiers?.length === 1"
        class="pt-2 ds-fine-print ds-color--grey-4 pricing-grid__left"
      >{{('productDetails.first' | cxTranslate) + ' '}}
        <span class="ds-color--white">{{tierRate?.minimumBlocks + '+'}}</span>
      </span>
      <span
        *ngIf="i === 0 && tierRate?.tiers?.length > 1"
        class="pt-2 ds-fine-print ds-color--grey-4 pricing-grid__left"
      >{{('productDetails.first' | cxTranslate) + ' '}}
        <span class="ds-color--white">{{tierRate?.minimumBlocks + ' - ' + tier.bound}}</span>
      </span>
      <span
        *ngIf="i > 0 && i < tierRate?.tiers.length - 1"
        class="pt-2 ds-fine-print ds-color--grey-4 pricing-grid__left"
      >{{('productDetails.next' | cxTranslate) + ' '}}
        <span class="ds-color--white">{{(tierRate?.tiers[i - 1].bound + 1) + ' - ' + tier.bound}}</span>
      </span>
      <span
        *ngIf="i !== 0 && i === tierRate?.tiers.length - 1"
        class="pt-2 ds-fine-print ds-color--grey-4 pricing-grid__left"
      >{{('productDetails.next' | cxTranslate) + ' '}}
        <span class="ds-color--white">{{(tierRate?.tiers[i - 1].bound + 1) + '+'}}</span>
      </span>
      <!-- cost -->
      <span
        class="pt-2 ds-fine-print ds-color--white pricing-grid__right"
      >{{ratePlan?.currency + ' ' + (tier.pricePerBlock?.amount | priceFormat)}}</span>
    </ng-container>
  </ng-container>
  <!-- Plan percentage rates (termination) -->
  <ng-container
    *ngIf="terminationRatePlanCommon?.percentageFees?.length
    || terminationRatePlanCommon?.fixedRates?.length
    || terminationRatePlanByCurrency?.percentageFees?.length
    || terminationRatePlanByCurrency?.fixedRates?.length"
  >
    <div class="my-4 separator pricing-grid__headline w-100"></div>
    <span
      class="pricing-grid__headline ds-heading--xs ds-color--white"
    >{{'productDetails.cancellationFee' | cxTranslate}}</span>
    <ng-container *ngFor="let percentageFee of terminationRatePlanCommon?.percentageFees; let i = index">
      <span
        [class.pt-2]="i > 0"
        [class.pt-3]="i === 0"
        class="ds-fine-print ds-color--grey-4 pricing-grid__left text-capitalize"
      >{{percentageFee.metric?.name + ':'}}</span>
      <span
        [class.pt-2]="i > 0"
        [class.pt-3]="i === 0"
        class="ds-fine-print ds-color--white pricing-grid__right"
      >{{(percentageFee.ratio * 100) + '%'}}</span>
    </ng-container>
    <ng-container *ngFor="let fixedRate of terminationRatePlanByCurrency?.fixedRates; let i = index">
      <span
        [class.pt-2]="i > 0 || terminationRatePlanCommon?.percentageFees?.length"
        [class.pt-3]="i === 0 && !terminationRatePlanCommon?.percentageFees?.length"
        class="ds-fine-print ds-color--grey-4 pricing-grid__left text-capitalize"
      >{{fixedRate.metric?.name + ':'}}</span>
      <span
        [class.pt-2]="i > 0 || terminationRatePlanCommon?.percentageFees?.length"
        [class.pt-3]="i === 0 && !terminationRatePlanCommon?.percentageFees?.length"
        class="ds-fine-print ds-color--white pricing-grid__right"
      >{{ratePlan?.currency + ' ' + (fixedRate.price?.amount | priceFormat)}}</span>
    </ng-container>
  </ng-container>
</div>
